
import {useFormContext} from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Unstable_Grid2';
import CardHeader from '@mui/material/CardHeader';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  fields: any[];
  loaiTuoiOptions: any[];
  onAdd: VoidFunction;
  onRemove: (index: number) => void;
  onLoaiTuoiChange: (index: number, value: string) => void;
};

export default function LoSamChiTietForm({
  fields,
  loaiTuoiOptions,
  onAdd,
  onRemove,
  onLoaiTuoiChange,
}: Props) {
  const mdUp = useResponsive('up', 'md');
  const { watch, setValue } = useFormContext();
  const values = watch();

  return (
    <>
      {mdUp && (
        <Grid md={3}>
          <Typography variant="h6" sx={{ mb: 0.5 }}>
            Chi tiết lô sâm
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Thông tin chi tiết về các loại tuổi sâm trong lô...
          </Typography>
        </Grid>
      )}

      <Grid xs={12} md={9}>
        <Card>
          {!mdUp && <CardHeader title="Chi tiết lô sâm" />}

          <Stack spacing={3} sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1">Danh sách chi tiết</Typography>
              <Button
                variant="outlined"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={onAdd}
              >
                Thêm chi tiết
              </Button>
            </Stack>

            {fields.length > 0 && (
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Loại tuổi</TableCell>
                      <TableCell>Số lượng</TableCell>
                      <TableCell>Trạng thái</TableCell>
                      <TableCell width={50} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fields.map((field, index) => (
                      <TableRow key={field.id}>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={values.chiTietLoSam[index]?.loSamLoaiTuoiId || 1}
                              onChange={(event) => onLoaiTuoiChange(index, String(event.target.value))}
                            >
                              {loaiTuoiOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.text}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            type="number"
                            value={values.chiTietLoSam[index]?.soLuong || 1}
                            onChange={(event) => setValue(`chiTietLoSam.${index}.soLuong`, Number(event.target.value))}
                            inputProps={{ min: 1 }}
                          />
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={values.chiTietLoSam[index]?.trangThai || 1}
                              onChange={(event) => setValue(`chiTietLoSam.${index}.trangThai`, Number(event.target.value))}
                            >
                              <MenuItem value={1}>Hoạt động</MenuItem>
                              <MenuItem value={2}>Không hoạt động</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="error"
                            onClick={() => onRemove(index)}
                          >
                            <Iconify icon="mingcute:delete-2-line" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {fields.length === 0 && (
              <Box
                sx={{
                  textAlign: 'center',
                  py: 3,
                  color: 'text.secondary',
                }}
              >
                <Typography variant="body2">
                  Chưa có chi tiết lô sâm nào. Nhấn &quot;Thêm chi tiết&quot; để bắt đầu.
                </Typography>
              </Box>
            )}
          </Stack>
        </Card>
      </Grid>
    </>
  );
}
